if (!customElements.get('gift-box-form')) {
  customElements.define(
    'gift-box-form',
    class GiftBoxForm extends HTMLElement {
      constructor() {
        super();
        this.checkboxInput = this.querySelector('[data-gift-box-checkbox]');
        this.giftBoxWrapper = this.querySelector('.gift-box-fields');
        this.priceElement = this.querySelector('[data-gift-box-price]');
        this.unitPrice = parseInt(this.dataset.giftBoxUnitPrice) || 0;
      }

      variantChangeUnsubscriber = undefined;
      quantityChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.handleVariantChange(event.data.variant);
        });

        // Listen for quantity changes
        this.quantityChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, (event) => {
          // Event data may be nested under event.data or directly on event
          const quantity = event?.data?.quantity || event?.quantity || 1;
          this.updatePriceDisplay(quantity);
        });

        // Also listen for quantity input changes directly
        this.setupQuantityListener();

        this.checkInitialVariant();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
        if (this.quantityChangeUnsubscriber) {
          this.quantityChangeUnsubscriber();
        }
      }

      setupQuantityListener() {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const quantityInput = productInfo.querySelector('quantity-input input[name="quantity"]');
        if (quantityInput) {
          quantityInput.addEventListener('change', () => {
            this.updatePriceDisplay(parseInt(quantityInput.value) || 1);
          });
          // Also listen for input events for real-time updates
          quantityInput.addEventListener('input', () => {
            this.updatePriceDisplay(parseInt(quantityInput.value) || 1);
          });
        }

        // Listen for clicks on quantity buttons
        const quantityWrapper = productInfo.querySelector('quantity-input');
        if (quantityWrapper) {
          quantityWrapper.addEventListener('click', () => {
            setTimeout(() => {
              const qty = parseInt(quantityInput?.value) || 1;
              this.updatePriceDisplay(qty);
            }, 50);
          });
        }
      }

      updatePriceDisplay(quantity) {
        if (!this.priceElement || !this.unitPrice) return;

        const totalPrice = this.unitPrice * quantity;
        const formattedPrice = this.formatMoney(totalPrice);
        this.priceElement.textContent = `+ ${formattedPrice}`;
      }

      formatMoney(cents) {
        // Format as GBP - adjust if needed for other currencies
        const amount = (cents / 100).toFixed(2);
        return `£${amount}`;
      }

      checkInitialVariant() {
        const productInfo = this.closest('product-info');
        if (!productInfo) return;

        const variantData = productInfo.querySelector('variant-selects [data-selected-variant]');
        if (variantData) {
          try {
            const variant = JSON.parse(variantData.innerHTML);
            this.handleVariantChange(variant);
          } catch (e) {
            console.error('Gift box form: Could not parse initial variant', e);
          }
        }
      }

      handleVariantChange(variant) {
        const show = this.matchesVariantTrigger(variant);

        if (this.giftBoxWrapper) {
          this.giftBoxWrapper.classList.toggle('hidden', !show);
        }

        if (!show && this.checkboxInput && this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
        }
      }

      matchesVariantTrigger(variant) {
        if (!variant) return false;

        // Normalize trigger: lowercase and remove spaces (handles "1kg" vs "1 kg")
        const trigger = (this.dataset.variantTrigger || '1kg').toLowerCase().replace(/\s+/g, '');

        // Check title (normalized)
        const title = (variant.title || '').toLowerCase().replace(/\s+/g, '');
        if (title.includes(trigger)) return true;

        // Check each option (normalized)
        for (let i = 1; i <= 3; i++) {
          const opt = variant[`option${i}`];
          if (opt && opt.toLowerCase().replace(/\s+/g, '').includes(trigger)) return true;
        }

        return false;
      }

      get isChecked() {
        return this.checkboxInput?.checked || false;
      }

      get giftBoxProductId() {
        return this.dataset.giftBoxProductId;
      }
    }
  );
}
